import { updateFileQuery } from '../mutations';
import makeRequest from '../../../../common/utils/makeRequest';







export default async function updateFile(
apiClient,
{
  organisationId,
  assetFileId,
  input
})
{
  const requestParams = {
    mutation: updateFileQuery,
    variables: {
      organisationId,
      assetFileId,
      input
    },
    context: {
      module: 'upload'
    }
  };
  const { data, error } = await makeRequest({ request: apiClient.mutate, requestParams });

  if (!data || !data.updateFile || error) {return null;}

  return data.updateFile;
}